import { createFileRoute } from '@tanstack/react-router';
import { DiagnosisChat } from '../components/DiagnosisChat';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <section className="mb-8">
        <h2 className="text-2xl font-bold tracking-tight">
          あなたの恋愛タイプを、学術的根拠つきで診断
        </h2>
        <p className="mt-3 text-sm text-aibo-ink/70 leading-relaxed">
          成人愛着スタイル尺度 (Brennan et al., 1998 / 中尾・加藤, 2004)、Big Five、
          愛を伝える5つの方法、ジェンダー差コミュニケーションの 4 つの知識ベースをもとに、
          あなたの恋愛傾向を 4 つのレンズで読み解きます。
        </p>
      </section>
      <DiagnosisChat />
    </div>
  );
}
